import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ApiService } from './api.service';

/** GET /environment (the subset the portal reads). */
interface EnvironmentPayload {
  readonly environment_name?: string;
  /** 2.1 (DCM-367): false/absent hides every post-start parent surface. */
  readonly parentPostStartUpdates?: boolean;
}

/**
 * 4.6 (X10, DCMPDEV-759 / DCM-367): the Parent Portal v1 feature switches from
 * GET /environment, read ONCE and cached for the session.
 *
 * The API omits `parentPostStartUpdates` until task 2.1 ships in that
 * environment; a missing flag means OFF (v1 behaviour), never ON.
 */
@Injectable({ providedIn: 'root' })
export class EnvironmentFlagsService extends ApiService {
  private pending: Promise<EnvironmentPayload | null> | null = null;

  /** TRUE when post-start updates, contact changes and the Individual Plan are open. */
  async parentPostStartUpdates(): Promise<boolean> {
    if (!this.pending) {
      // A failed read must not open the post-start surfaces: cache the failure.
      this.pending = firstValueFrom(this.get<EnvironmentPayload>('environment')).catch(() => null);
    }
    const env = await this.pending;
    return env?.parentPostStartUpdates === true;
  }

  /** Test seam: forget the cached read. */
  reset(): void {
    this.pending = null;
  }
}
